import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { themeProps } from './theme';

const useStyles = makeStyles()((theme: Theme) => ({
  configCloseBtn: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },

  configContainer: {
    position: 'absolute',
    top: 60,
    left: 50,
    width: '450px',
    zIndex: 11,
    overflow: 'auto',
    borderRadius: '8px',
    height: 'calc(100vh - 150px)',
  },

  autoComplete: {
    color: theme.palette.text.primary,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
  },
  disabledShade: {
    position: 'absolute',
    top: 160,
    left: 0,
    right: 0,
    bottom: 0,
    background: `${theme.palette.primary.light}90`,
    borderRadius: '8px',
    zIndex: 1,
    pointerEvents: 'all', // prevents clicks
    cursor: 'not-allowed',
  },

  tagPill: {
    fontSize: themeProps.textSize.small,
    border: `solid 1px ${theme.palette.text.primary}75`,
    padding: ' 0 5px',
    borderRadius: '8px',
  },
}));

export default useStyles;
